<!-- <mat-form-field class="example-full-width">
  <input matInput [textMask]="{mask: datemask}" [(ngModel)]="myModel" placeholder="Type a date" value="01/03/2019">
</mat-form-field> --> 
<router-outlet></router-outlet>


<!-- {{ message | async | json }} -->